import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthRequest } from './request';
import { AuthCallback } from './callback';

const Auth = () => {
  return (
    <Routes>
      <Route path="request" element={<AuthRequest />} />
      <Route path="callback" element={<AuthCallback />} />
      <Route path="*" element={<AuthRequest />} />
    </Routes>
  );
};
export default Auth;
